/**
 * ANAEROBIC — Theme JavaScript
 * Vanilla JS, no frameworks. ~5KB.
 */
(function() {
  'use strict';

  /* ==========================================================
     SCROLL DETECTION — Sticky header shadow
     ========================================================== */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    let ticking = false;
    function onScroll() {
      lastScroll = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(function() {
          header.classList.toggle('is-scrolled', lastScroll > 10);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ==========================================================
     DESKTOP DROPDOWNS — Asymmetric hover intent: fast in, forgiving out.
     Open is 60ms (just enough to ignore a cursor sweeping across the bar);
     close is 220ms so a diagonal move from the trigger into the panel doesn't
     dismiss it mid-travel. Both were 150ms, which read as a slow nav.
     ========================================================== */
  /* Anchor a mega panel to the nav item that opened it, clamped inside the viewport.
     Panels used to open centred regardless of trigger, so the eye had to travel. */
  function positionMega(item) {
    var panel = item.querySelector('.site-nav__dropdown--mega');
    if (!panel) return;
    var parent = panel.offsetParent;
    if (!parent) return;
    var pRect = parent.getBoundingClientRect();
    var iRect = item.getBoundingClientRect();
    var w = panel.offsetWidth;
    var gutter = 18;
    var desired = (iRect.left + iRect.width / 2) - (w / 2) - pRect.left;  // centre on the nav item
    var minLeft = gutter - pRect.left;
    var maxLeft = (window.innerWidth - gutter - w) - pRect.left;
    if (maxLeft < minLeft) maxLeft = minLeft;
    var left = Math.max(minLeft, Math.min(desired, maxLeft));
    panel.style.setProperty('--mega-left', left + 'px');
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-dropdown]').forEach(positionMega);
  });
  requestAnimationFrame(function () {
    document.querySelectorAll('[data-dropdown]').forEach(positionMega);
  });

  const dropdownItems = document.querySelectorAll('[data-dropdown]');
  dropdownItems.forEach(function(item) {
    let timeout;
    item.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        closeAllDropdowns();
        positionMega(item);
        item.classList.add('is-open');
        var link = item.querySelector('.site-nav__link');
        if (link) link.setAttribute('aria-expanded', 'true');
      }, 60);
    });
    item.addEventListener('mouseleave', function() {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        item.classList.remove('is-open');
        var link = item.querySelector('.site-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }, 220);
    });
    // Keyboard support
    item.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        closeAllDropdowns();
        if (!isOpen) {
          item.classList.add('is-open');
          var link = item.querySelector('.site-nav__link');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      }
      if (e.key === 'Escape') {
        closeAllDropdowns();
      }
    });
  });

  function closeAllDropdowns() {
    dropdownItems.forEach(function(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.site-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-dropdown]')) {
      closeAllDropdowns();
    }
  });

  /* ==========================================================
     MOBILE NAVIGATION — Slide-in drawer
     ========================================================== */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-close]');
  var mobileOverlay = document.querySelector('[data-mobile-overlay]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Focus first element
    var firstLink = mobileNav.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    if (mobileToggle) {
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.focus();
    }
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  // Close on navigation. Without this the drawer is still open (and the body
  // still scroll-locked) when the browser restores this page from bfcache on
  // a back-swipe — which on iOS leaves the page unscrollable.
  if (mobileNav) {
    mobileNav.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (a && !a.hasAttribute('data-accordion-toggle')) closeMobileNav();
      // The Start-here tile's Add (2026-09-09): close the drawer so the cart (z 1000) is not
      // opened behind the menu (z 2000).
      if (e.target.closest('.mobile-nav__feature-add')) closeMobileNav();
    });
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav();
  });

  // Escape key closes mobile nav
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileNav();
    }
  });

  /* ==========================================================
     SEARCH OVERLAY — 2026-08-11
     The button existed with [data-search-toggle] and had no handler and no
     overlay to open; tapping it did nothing. Predictive results come from
     Shopify's /search/suggest.json, so there is no app and no token here.
     The form still posts to /search, so with JS off the button degrades to
     the normal results page rather than dying again.
     ========================================================== */
  var searchToggle  = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput   = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');

  if (searchToggle && searchOverlay && searchInput) {
    var searchLastFocus = null;
    var searchTimer = null;
    var searchSeq = 0;   // guards against a slow early request overwriting a fast later one

    function openSearch() {
      searchLastFocus = document.activeElement;
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // iOS will not focus an input from a handler unless it is already
      // visible, hence the frame delay rather than an immediate .focus().
      requestAnimationFrame(function () { searchInput.focus(); });
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (searchResults) searchResults.innerHTML = '';
      searchInput.value = '';
      if (searchLastFocus && searchLastFocus.focus) {
        try { searchLastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      searchOverlay.classList.contains('is-open') ? closeSearch() : openSearch();
    });

    searchOverlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch();
    });

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // /search/suggest.json returns price as a bare string ("45.00") with no
    // currency symbol. The store renders whole-dollar prices on every card
    // (founder 2026-08-01), so match that here rather than shipping a third
    // price format into the same page.
    function fmtPrice(p) {
      var n = parseFloat(p);
      if (isNaN(n)) return '';
      return '$' + Math.round(n);
    }

    function render(term, products, articles) {
      if (!searchResults) return;
      var html = '';
      if (products.length) {
        html += '<ul class="search-overlay__list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url
            // eager, not lazy: there are at most five and they ARE the result
            // — lazily loading content that only exists once the panel is
            // already open just delays the paint it was meant to save.
            ? '<img class="search-overlay__thumb" src="' + esc(p.featured_image.url) + '&width=120" alt="" decoding="async" width="48" height="48">'
            : '<span class="search-overlay__thumb search-overlay__thumb--ph" aria-hidden="true"></span>';
          html += '<li><a class="search-overlay__hit" href="' + esc(p.url) + '">' + img +
                  '<span class="search-overlay__hit-body"><span class="search-overlay__hit-title">' + esc(p.title) + '</span>' +
                  (fmtPrice(p.price) ? '<span class="search-overlay__hit-meta">' + esc(fmtPrice(p.price)) + '</span>' : '') +
                  '</span></a></li>';
        });
        html += '</ul>';
      }
      if (articles.length) {
        html += '<p class="search-overlay__group">Journal</p><ul class="search-overlay__list">';
        articles.forEach(function (a) {
          html += '<li><a class="search-overlay__hit search-overlay__hit--article" href="' + esc(a.url) + '">' +
                  '<span class="search-overlay__hit-body"><span class="search-overlay__hit-title">' + esc(a.title) + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (!html) {
        html = '<p class="search-overlay__empty">No matches for “' + esc(term) + '”.</p>';
      }
      html += '<a class="search-overlay__all" href="/search?q=' + encodeURIComponent(term) + '">' +
              'See all results for “' + esc(term) + '” &rarr;</a>';
      searchResults.innerHTML = html;
    }

    function runSearch(term) {
      var mySeq = ++searchSeq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product,article&resources[limit]=5', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (mySeq !== searchSeq) return;   // a newer keystroke already won
          var res = (data && data.resources && data.resources.results) || {};
          render(term, res.products || [], res.articles || []);
        })
        .catch(function () {
          if (mySeq !== searchSeq || !searchResults) return;
          searchResults.innerHTML = '<a class="search-overlay__all" href="/search?q=' +
            encodeURIComponent(term) + '">See all results for “' + esc(term) + '” &rarr;</a>';
        });
    }

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (term.length < 2) { if (searchResults) searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () { runSearch(term); }, 220);
    });
  }

  /* ==========================================================
     MOBILE ACCORDION SUBMENUS
     ========================================================== */
  var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
  accordionToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var parent = toggle.closest('.mobile-nav__item');
      if (!parent) return;
      var isOpen = parent.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.mobile-nav__item.is-open').forEach(function(item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-accordion-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      // Toggle current
      if (!isOpen) {
        parent.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ==========================================================
     PRODUCT GALLERY — Thumbnail switching
     ========================================================== */
  var thumbBtns = document.querySelectorAll('[data-thumb-btn]');
  var featuredImg = document.getElementById('product-featured-img');

  thumbBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (!featuredImg) return;
      var newSrc = btn.getAttribute('data-image-url');
      if (newSrc) {
        /* The featured <img> ships with a srcset. Setting .src alone leaves the
           browser free to keep painting the ORIGINAL srcset candidate, so the
           gallery looked stuck. Drop srcset/sizes first. Fixed 2026-08-13. */
        featuredImg.removeAttribute('srcset');
        featuredImg.removeAttribute('sizes');
        featuredImg.src = newSrc;
        // Update active state
        thumbBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }
    });
  });

  /* ==========================================================
     QUANTITY SELECTORS
     ========================================================== */
  document.querySelectorAll('[data-quantity]').forEach(function(wrap) {
    var input = wrap.querySelector('[data-quantity-input]');
    var minus = wrap.querySelector('[data-quantity-minus]');
    var plus = wrap.querySelector('[data-quantity-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        var max = parseInt(input.max) || 99;
        if (val < max) {
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });

  /* ==========================================================
     VARIANT SELECTOR — PDP variant switching
     ========================================================== */
  var productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      var product = JSON.parse(productJson.textContent);
      var optionSelects = document.querySelectorAll('[data-option-select]');
      var variantIdInput = document.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = document.querySelector('[data-add-to-cart]');

      optionSelects.forEach(function(select) {
        select.addEventListener('change', function() {
          var selectedOptions = [];
          optionSelects.forEach(function(s) { selectedOptions.push(s.value); });

          var variant = product.variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === selectedOptions[i];
            });
          });

          if (variant) {
            if (variantIdInput) variantIdInput.value = variant.id;
            if (priceEl) {
              priceEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.price) :
                '$' + (variant.price / 100).toFixed(2);
            }
            if (addBtn) {
              addBtn.disabled = !variant.available;
              addBtn.innerHTML = variant.available ?
                'Add to Cart <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' :
                'Sold Out';
            }
            // Update URL
            var url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        });
      });
    } catch(e) {
      console.warn('Could not parse product JSON', e);
    }
  }

  /* ==========================================================
     COLLECTION SORT
     ========================================================== */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  /* ==========================================================
     IMAGE FADE-IN ON LOAD
     ========================================================== */
  document.querySelectorAll('.product-card__image, .collection-card__image').forEach(function(img) {
    if (img.complete) {
      img.style.opacity = '1';
    } else {
      img.addEventListener('load', function() {
        img.style.animationPlayState = 'running';
      });
    }
  });

  /* ==========================================================
     ANNOUNCEMENT BAR ROTATION
     ========================================================== */
  var announceSlider = document.querySelector('[data-announce-slider]');
  if (announceSlider && announceSlider.children.length > 1) {
    var aIdx = 0;
    var aTotal = announceSlider.children.length;
    setInterval(function() {
      aIdx = (aIdx + 1) % aTotal;
      announceSlider.style.transform = 'translateX(-' + (aIdx * 100) + '%)';
    }, 4000);
  }

  /* ==========================================================
     CART DRAWER
     ========================================================== */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartTrigger = document.querySelector('[data-cart-trigger]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCartDrawer() {
    if (cartDrawer) { cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); }
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartDrawer) { cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  /* ==========================================================
     STICKY ATC BAR (mobile)
     ========================================================== */
  var stickyBar = document.querySelector('.sticky-atc');
  var mainAtcBtn = document.querySelector('[data-add-to-cart]');
  if (stickyBar && mainAtcBtn) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAtcBtn);
  }

  /* ==========================================================
     WHOLESALE — Bold editorial: rail + fade-ins + supply reveal
     ========================================================== */
  (function initWholesaleBold() {
    var root = document.getElementById('wholesale');
    if (!root) return;
    var chapters = Array.prototype.slice.call(root.querySelectorAll('.ws-chapter'));
    if (!chapters.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rail = root.querySelector('.ws-rail');
    var topbar = root.querySelector('.ws-topbar');

    // Background masthead video: pause for reduce-motion users, retry .play() for
    // autoplay-strict browsers (iOS Safari). Poster image stays if autoplay blocked.
    var mhVideo = root.querySelector('.ws-masthead__video');
    if (mhVideo) {
      if (reduced) {
        try { mhVideo.pause(); } catch (err) {}
        mhVideo.removeAttribute('autoplay');
      } else {
        var p = mhVideo.play && mhVideo.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked — poster stays */ });
      }
    }

    // Show rail/topbar only while #wholesale is in viewport
    if ('IntersectionObserver' in window) {
      var inviewObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var visible = e.isIntersecting && e.intersectionRatio > 0.02;
          if (rail) rail.classList.toggle('is-inview', visible);
          if (topbar) topbar.classList.toggle('is-inview', visible);
        });
      }, { threshold: [0, 0.02, 0.1] });
      inviewObs.observe(root);
    } else {
      if (rail) rail.classList.add('is-inview');
      if (topbar) topbar.classList.add('is-inview');
    }

    // Fade-in chapters on enter
    if ('IntersectionObserver' in window && !reduced) {
      var fadeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            fadeObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
      chapters.forEach(function (c) { fadeObs.observe(c); });
    } else {
      chapters.forEach(function (c) { c.classList.add('is-visible'); });
    }

    // Chapter rail: track current chapter + progress fill
    var railItems = Array.prototype.slice.call(root.querySelectorAll('.ws-rail__item'));
    var railFill = document.getElementById('ws-rail-fill');
    var topFill  = document.getElementById('ws-topbar-fill');
    var topN     = document.getElementById('ws-topbar-n');
    var topT     = document.getElementById('ws-topbar-t');

    function setActiveChapter(idx) {
      railItems.forEach(function (item, i) {
        if (i === idx) item.classList.add('is-active');
        else item.classList.remove('is-active');
      });
      var ch = chapters[idx];
      if (topN && ch) topN.textContent = ('0' + (idx + 1)).slice(-2);
      if (topT && ch) topT.textContent = ch.getAttribute('data-chapter-title') || '';
    }

    function updateActiveChapter() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var probe = vh * 0.35;
      var current = 0;
      for (var i = 0; i < chapters.length; i++) {
        var top = chapters[i].getBoundingClientRect().top;
        if (top <= probe) current = i;
        else break;
      }
      setActiveChapter(current);
    }

    function updateProgress() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = rect.height - vh;
      if (total <= 0) return;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var pct = (scrolled / total) * 100;
      if (railFill) railFill.style.height = pct + '%';
      if (topFill)  topFill.style.width  = pct + '%';
      updateActiveChapter();
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { updateProgress(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();

    // Rail click → smooth scroll
    railItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var id = item.getAttribute('data-target');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var behavior = reduced ? 'auto' : 'smooth';
        target.scrollIntoView({ behavior: behavior, block: 'start' });
      });
    });

    // Supply-chain diagram: sequential stage activation on Chapter 3 enter (once)
    var supply = document.getElementById('ws-supply-stages');
    if (supply && 'IntersectionObserver' in window) {
      var stages = Array.prototype.slice.call(supply.querySelectorAll('.ws-supply__stage'));
      var fired = false;
      var sObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || fired) return;
          fired = true;
          sObs.unobserve(e.target);
          if (reduced) {
            stages.forEach(function (s) { s.classList.add('is-active'); });
            return;
          }
          stages.forEach(function (s, i) {
            setTimeout(function () { s.classList.add('is-active'); }, i * 320);
          });
        });
      }, { threshold: 0.25 });
      sObs.observe(supply);
    } else if (supply) {
      Array.prototype.slice.call(supply.querySelectorAll('.ws-supply__stage'))
        .forEach(function (s) { s.classList.add('is-active'); });
    }
  })();

})();
/* cart-drawer + 2-bar rewards system wired in 2026-05-13 — see snippets/cart-drawer.liquid */

/* In-app browser note (2026-09-09, audit finding 9): Instagram / Facebook / Threads open links in
   their own webview, where Apple Pay is not offered and saved wallets do not persist. Flags
   [data-cart-iab] in the cart drawer; the CSS shows it only with .is-on. */
(function () {
  var ua = navigator.userAgent || '';
  if (!/Instagram|FBAN|FBAV|FB_IAB|FBIOS|Barcelona/i.test(ua)) return;
  var mark = function () {
    var nodes = document.querySelectorAll('[data-cart-iab]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-on');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();

/* Internal traffic marker (2026-09-09, desktop audit finding 1). Visit any page with ?internal=1
   once on a browser you test from; ?internal=0 clears it. Sets a one-year first-party cookie,
   stamps <html data-internal="1">, and tells the Google tag (traffic_type=internal) when it is
   on the page, so a GA4 internal-traffic filter can drop these sessions. Shopify's own session
   reports cannot be filtered — GA4 becomes the source of truth for desktop conversion. */
(function () {
  try {
    var m = location.search.match(/[?&]internal=([01])/);
    if (m) {
      document.cookie = 'anr_internal=' + m[1] + '; path=/; max-age=' + (m[1] === '1' ? 31536000 : 0) + '; SameSite=Lax; Secure';
    }
    var on = /(^|;\s*)anr_internal=1(;|$)/.test(document.cookie);
    if (!on) return;
    document.documentElement.setAttribute('data-internal', '1');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'anr_internal', traffic_type: 'internal' });
    if (typeof window.gtag === 'function') window.gtag('set', { traffic_type: 'internal' });
  } catch (e) {}
})();
